module.exports = __webpack_public_path__ + "assets/images/01-full_693090a03b1591f6085161ea25ddc345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/01-full.png
// module id = 160
// module chunks = 0